module.exports = "<div class=\"inner-popover\">\n    <div class=\"arrow\"></div>\n    <div class=\"content\"></div>\n</div>\n"